module.exports = __webpack_public_path__ + "dash_20_app_assets/img/multiplechoiceanswer.719f1926.png";